module.exports = "https://img.xiyuyouxi.com/saas/img/rmb_icon2.1e52f767.png";